import React, { memo, useMemo } from 'react';
import dayjs from 'dayjs';

import scss from './TimeLabel.module.scss';

function TimeLabel({ time }) {
  const hhMM = useMemo(() => (dayjs(time).isValid() ? dayjs(time).format('HH:mm') : '-/-'), [time]);

  return <span className={scss.timeLabel}>{hhMM}</span>;
}

export default memo(TimeLabel);
